import { Directive, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
  selector: '[appEnterKey]'
})
export class EnterKeyComponent {
  @Output() enterKey: EventEmitter<void> = new EventEmitter<void>();

  @HostListener('keyup.enter')
  onEnterKey(): void {
    this.enterKey.emit();
  }
}
